/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.layouts.tickets.controllers', [])

.controller('LayoutsTicketsController', ['$scope', function($scope) {

    $scope.layoutsTickets = {

      model: "Your spankin new application.layouts.tickets.default view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.layoutsTickets.init();

}]);